import store from '@/store/store'
import jwtDecode from 'jwt-decode'

export default (to, from, next) => {
  const decoded = jwtDecode(store.state.token)
  if (store.state.isUserLoggedIn && !(decoded.exp * 1000 < Date.now())) {
    next()
  } else {
    next('/loginTimeout')
  }
}



// WEBPACK FOOTER //
// ./src/router/auth-guard.js